// extracted by mini-css-extract-plugin
module.exports = {"homeBody":"index__homeBody___3aUDk"};